import * as XLSX from 'xlsx';

function generateExcel(data, outputFileName = "InvestorData.xlsx") {
    // Function to flatten nested JSON
    const flattenObject = (obj, parentKey = '') => {
        let flattened = [];
        for (let key in obj) {
            if (typeof obj[key] === 'object' && obj[key] !== null) {
                flattened = flattened.concat(flattenObject(obj[key], `${parentKey}${key}.`));
            } else {
                flattened.push({ Field: `${parentKey}${key}`, Value: obj[key] });
            }
        }
        return flattened;
    };

    // Convert data to worksheet
    const worksheetData = flattenObject(data);
    const worksheet = XLSX.utils.json_to_sheet(worksheetData, { header: ["Field", "Value"] });

    // Create workbook and append worksheet
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "Data");

    // Save the file in the browser
    XLSX.writeFile(workbook, outputFileName);
}

export default generateExcel;
